import request from '@/api/config/request'

const prex = "api/admin/gestao/pedidos_cancelamento";

export function listPedidosCancelamento(query = {}) {
    return request({
        url: `${prex}`,
        method: 'get',
        params: query
    })
}

export function postPedidosCancelamento(data) {
    return request({
        url: `${prex}`,
        method: 'post',
        data
    })
}
